import React, { useEffect, useState } from 'react';
import '../../assets/css/Home/Home_Antenne.css';
import { API_BASE_URL } from '../../utils/config';

function AntenneBlock() {
    const [antennes, setAntennes] = useState([]);
    const [loading, setLoading] = useState(true);  // État pour le loader

    useEffect(() => {
        fetch(`${API_BASE_URL}/antennes/home`)
            .then((response) => response.json())
            .then((data) => {
                const formattedData = data.map((antenne, index) => ({
                    id: antenne.id,
                    title: antenne.nom,
                    description: 'Découvrir cette antenne',
                    link: `/antenne/${antenne.id}`,
                    color: index % 2 === 0 ? '#cc0000' : '#016698',
                }));
                setAntennes(formattedData);
                setLoading(false);  // Les données sont chargées
            })
            .catch((error) => {
                console.error('Erreur lors de la récupération des antennes:', error);
                setLoading(false);  // Arrête le chargement même en cas d'erreur
            });
    }, []);

    return (
        <section id="nous-trouver">
            <div className="container my-5">
                <h2 className="section-title">Nos Antennes</h2>
                {loading ? (
                    <div className="row">
                        {[...Array(4)].map((_, index) => (
                            <div key={index} className="col-md-3 mb-4">
                                <div className="card-placeholder h-100">
                                    <div className="card-body-placeholder">
                                        <div className="placeholder-title"></div>
                                        <div className="placeholder-line"></div>
                                        <div className="placeholder-line"></div>
                                        <div className="text-end">
                                            <span className="arrow-icon">&rarr;</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="row">
                        {antennes.map((antenne, index) => (
                            <div key={index} className="col-md-3 mb-4">
                                <div
                                    className="card text-white h-100"
                                    style={{ backgroundColor: antenne.color }}
                                >
                                    <div className="card-body d-flex flex-column justify-content-between">
                                        <h5 className="card-title">{antenne.title}</h5>
                                        <p className="card-text">{antenne.description}</p>
                                        <div className="text-end">
                                            <a
                                                href={antenne.link}
                                                className="stretched-link text-white text-decoration-none"
                                            >
                                                <span className="arrow-icon">&rarr;</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}

export default AntenneBlock;
